export const ActionTypes = {
  FETCH_JOB_HISTORY_OPERATION: 'services/jobHistoryOperation/fetch_job_history_operation',
  SET_JOB_HISTORY_OPERATION: 'services/jobHistoryOperation/set_job_history_operation',
  SET_JOB_HISTORY_OPERATION_LOADER_STATUS: 'services/jobHistoryOperation/set_job_history_operation_loader_status',
  UPDATE_JOB_HISTORY_OPERATION: 'services/jobHistoryOperation/update_job_history_operation',
};

const fetchJobHistoryOperation = ({ jobHistoryOperationParams }) => ({
  jobHistoryOperationParams,
  type: ActionTypes.FETCH_JOB_HISTORY_OPERATION,
});

const setJobHistoryOperation = ({ jobHistoryOperationData }) => ({
  jobHistoryOperationData,
  type: ActionTypes.SET_JOB_HISTORY_OPERATION,
});

const updateJobHistoryOperation = ({ jobHistoryOperationObj, jobHistoryOperationParams }) => ({
  jobHistoryOperationObj,
  jobHistoryOperationParams,
  type: ActionTypes.UPDATE_JOB_HISTORY_OPERATION,
});

const setJobHistoryOperationLoaderStatus = ({ jobHistoryOperationLoader }) => ({
  jobHistoryOperationLoader,
  type: ActionTypes.SET_JOB_HISTORY_OPERATION_LOADER_STATUS,
});

export default {
  fetchJobHistoryOperation,
  setJobHistoryOperation,
  updateJobHistoryOperation,
  setJobHistoryOperationLoaderStatus,
};
